module.exports = __webpack_public_path__ + "img/SchlafenInBasedow.b6bbe88b.jpg";